import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/bd-mobile-next/app/components/article/ArticleTemplate.tsx");
